import {ModalCopy_CurrentStep, ModalCopy_Type} from "../@const"
import ProjectSession from "../../../model2/project/project-session"
import {Copy_Manager} from "./manager"
import {ModalCopy_Params} from "../@types"
import ApiProject from "../../../gd/api/project";
import ProjectViewsLookup from "../../../model2/project/inheritance/project-views-lookup";

// const debug = "CopyProject_Manager"
const debug = false

export class CopyProject_Manager extends Copy_Manager {

    public projectToCopy        : ProjectSession

    public copyAsTemplate       : boolean               // if true we create local template (!)
    public redirectToCopy       : boolean
    public rescheduleRequired   : boolean = false

    constructor(project: ProjectSession, params?: ModalCopy_Params) {
        super(ModalCopy_Type.PROJECT)

        this.projectToCopy  = project
        this.copyAsTemplate = _.get(params, 'copyAsTemplate', false)
        this.redirectToCopy = _.get(params, 'redirectToCopy', true)
    }

    init = async () => {
        if (!this.projectToCopy.isTemplate) {
            const response = await gd.api.Project.getCopyParams(this.projectToCopy.id).promise()
            this.rescheduleRequired = response.rescheduleRequired
        }

        this.setCurrentStep(ModalCopy_CurrentStep.COPY_PROJECT)
    }

    get modalTitle():string {
        return this.copyAsTemplate ? 'Save as Template' : 'Duplicate Project'
    }

    get affectedProjectIds(): ID[] {
        return[this.projectToCopy.id]
    }

    async commitCopy(result?: any) {
        if (result) this.result = result

        const projectViews = new ProjectViewsLookup(this.projectToCopy.id).get()

        let request

        if (this.copyAsTemplate) {
            // we have separate call now
            request =  ApiProject.saveAsTemplate(this.projectToCopy.id, {
                name                : this.result.name,

                description         : this.result.description,
                prefix              : this.result.prefix,

                copyTasks           : this.result.copyOptions.includes("tasks"),
                copyUsers           : this.result.copyOptions.includes("users"),
                copySubProjects     : this.result.copyOptions.includes("subprojects"),
                copyEvents          : this.result.copyOptions.includes("events"),
                copyCustomFields    : this.result.copyOptions.includes("customFields"),

                planningStartDate   : this.result.startDate ? this.result.startDate.format("YYYY-MM-DD") : null,
                planningEndDate     : this.result.endDate ? this.result.endDate.format("YYYY-MM-DD") : null,

                views               : projectViews
            });
        } else {
            // duplicate project
            request =  ApiProject.copyProject(this.projectToCopy.id, {
                toProjectId         : this.result.parentProject,
                name                : this.result.name,

                description         : this.result.description,
                prefix              : this.result.prefix,

                copyTasks           : this.result.copyOptions.includes("tasks"),
                copyUsers           : this.result.copyOptions.includes("users"),
                copySubProjects     : this.result.copyOptions.includes("subprojects"),
                copyEvents          : this.result.copyOptions.includes("events"),
                copyCustomFields    : this.result.copyOptions.includes("customFields"),

                planningStartDate   : this.result.startDate ? this.result.startDate.format("YYYY-MM-DD") : null,
                planningEndDate     : this.result.endDate ? this.result.endDate.format("YYYY-MM-DD") : null,

                copyAsTemplate      : false
            })
        }

        request.done((response: any)=>{
            const newProject: ProjectSession = gd.session.projects.get(response.projectId)!
            const goToProject = this.redirectToCopy && !newProject.properties.handleExpandInsteadOfOpen && !newProject.isLink
            if (goToProject) gd.navigation.goToProject(response.projectId)

            this.onCopy?.()
            gd.modal.hide()
        })
    }
}